import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 dark:bg-black text-white py-6">
      <div className="text-center text-gray-400">
        © {currentYear} Creativa
      </div>
    </footer>
  );
};

export default Footer;
